import api from "./api";

const controller = "/GrupoCargo/";

export const getGrupoCargoViewById = async (id) => {
    const response = await api.get(controller + "GetGrupoCargoViewById", { params: { id } });
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const postGrupoCargo = async (dataPost) => {
    const response = await api.post(controller + "PostGrupoCargo", dataPost);
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const getsGrupoCargoViewSearchBasic = async (descripcion = "", idEstado = 0) => {
    const response = await api.get(controller + "GetsGrupoCargoViewSearchBasic", {
        params: { descripcion, idEstado }
    });
    return response.data?.data !== undefined ? response.data.data : response.data;
};

export const annulGrupoCargo = (id) =>
    api.post(controller + "AnnulGrupoCargo?idGrupoCargo=" + id);

export const activeGrupoCargo = (id) =>
    api.post(controller + "ActiveGrupoCargo?idGrupoCargo=" + id);

export default {
    getGrupoCargoViewById,
    postGrupoCargo,
    getsGrupoCargoViewSearchBasic,
    annulGrupoCargo,
    activeGrupoCargo
};

